/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeasurementDtoDataResponse } from '../models/MeasurementDtoDataResponse';
import type { MeasurementValueDto } from '../models/MeasurementValueDto';
import type { TemplateDtoDataResponse } from '../models/TemplateDtoDataResponse';
import type { WorkbenchCalculationDto } from '../models/WorkbenchCalculationDto';
import type { WorkbenchCalculationDtoDataResponse } from '../models/WorkbenchCalculationDtoDataResponse';
import type { WorkbenchDto } from '../models/WorkbenchDto';
import type { WorkbenchDtoDataResponse } from '../models/WorkbenchDtoDataResponse';
import type { WorkbenchFilterDto } from '../models/WorkbenchFilterDto';
import type { WorkbenchFilterDtoDataResponse } from '../models/WorkbenchFilterDtoDataResponse';
import type { WorkbenchMutationDto } from '../models/WorkbenchMutationDto';
import type { WorkbenchSourceDto } from '../models/WorkbenchSourceDto';
import type { WorkbenchSourceDtoDataResponse } from '../models/WorkbenchSourceDtoDataResponse';
import type { WorkbenchSourceMutationDto } from '../models/WorkbenchSourceMutationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkbenchService {

  /**
   * @returns WorkbenchDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenches({
    projectReference,
    after,
    before,
    first,
    last,
  }: {
    projectReference: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches',
      path: {
        'projectReference': projectReference,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchDto OK
   * @throws ApiError
   */
  public static createWorkbench({
    projectReference,
    requestBody,
  }: {
    projectReference: string,
    requestBody?: WorkbenchMutationDto,
  }): CancelablePromise<WorkbenchDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches',
      path: {
        'projectReference': projectReference,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchDto OK
   * @throws ApiError
   */
  public static getWorkbench({
    projectReference,
    workbenchId,
  }: {
    projectReference: string,
    workbenchId: string,
  }): CancelablePromise<WorkbenchDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static updateWorkbench({
    projectReference,
    workbenchId,
    requestBody,
  }: {
    projectReference: string,
    workbenchId: string,
    requestBody?: WorkbenchMutationDto,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static recalculateMeasurements({
    projectReference,
    workbenchId,
  }: {
    projectReference: string,
    workbenchId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/RecalculateMeasurements',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
    });
  }

  /**
   * @returns WorkbenchSourceDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchSources({
    projectReference,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectReference: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchSourceDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/sources',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchSourceDto OK
   * @throws ApiError
   */
  public static createWorkbenchSource({
    projectReference,
    workbenchId,
    requestBody,
  }: {
    projectReference: string,
    workbenchId: string,
    requestBody?: WorkbenchSourceMutationDto,
  }): CancelablePromise<WorkbenchSourceDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/sources',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchSourceDto OK
   * @throws ApiError
   */
  public static getWorkbenchSource({
    projectReference,
    workbenchId,
    sourceId,
  }: {
    projectReference: string,
    workbenchId: string,
    sourceId: string,
  }): CancelablePromise<WorkbenchSourceDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/sources/{sourceId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'sourceId': sourceId,
      },
    });
  }

  /**
   * @returns WorkbenchSourceDto OK
   * @throws ApiError
   */
  public static updateWorkbenchSource({
    projectReference,
    workbenchId,
    sourceId,
    requestBody,
  }: {
    projectReference: string,
    workbenchId: string,
    sourceId: string,
    requestBody?: WorkbenchSourceMutationDto,
  }): CancelablePromise<WorkbenchSourceDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/sources/{sourceId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'sourceId': sourceId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static deleteWorkbenchSource({
    projectReference,
    workbenchId,
    sourceId,
  }: {
    projectReference: string,
    workbenchId: string,
    sourceId: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/sources/{sourceId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'sourceId': sourceId,
      },
    });
  }

  /**
   * @returns WorkbenchFilterDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchFilters({
    projectReference,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectReference: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchFilterDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/filters',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchFilterDto OK
   * @throws ApiError
   */
  public static createWorkbenchFilter({
    projectReference,
    workbenchId,
    requestBody,
  }: {
    projectReference: string,
    workbenchId: string,
    requestBody?: WorkbenchFilterDto,
  }): CancelablePromise<WorkbenchFilterDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/filters',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchFilterDto OK
   * @throws ApiError
   */
  public static getWorkbenchFilter({
    projectReference,
    workbenchId,
    filterId,
  }: {
    projectReference: string,
    workbenchId: string,
    filterId: string,
  }): CancelablePromise<WorkbenchFilterDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/filters/{filterId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'filterId': filterId,
      },
    });
  }

  /**
   * @returns WorkbenchFilterDto OK
   * @throws ApiError
   */
  public static updateWorkbenchFilter({
    projectReference,
    workbenchId,
    filterId,
    requestBody,
  }: {
    projectReference: string,
    workbenchId: string,
    filterId: string,
    requestBody?: WorkbenchFilterDto,
  }): CancelablePromise<WorkbenchFilterDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/filters/{filterId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'filterId': filterId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static deleteWorkbenchFilter({
    projectReference,
    workbenchId,
    filterId,
  }: {
    projectReference: string,
    workbenchId: string,
    filterId: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/filters/{filterId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'filterId': filterId,
      },
    });
  }

  /**
   * @returns WorkbenchCalculationDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchCalculations({
    projectReference,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectReference: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchCalculationDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/calculations',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchCalculationDto OK
   * @throws ApiError
   */
  public static createWorkbenchCalculation({
    projectReference,
    workbenchId,
    requestBody,
  }: {
    projectReference: string,
    workbenchId: string,
    requestBody?: WorkbenchCalculationDto,
  }): CancelablePromise<WorkbenchCalculationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/calculations',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchCalculationDto OK
   * @throws ApiError
   */
  public static getWorkbenchCalculation({
    projectReference,
    workbenchId,
    calculationId,
  }: {
    projectReference: string,
    workbenchId: string,
    calculationId: string,
  }): CancelablePromise<WorkbenchCalculationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/calculations/{calculationId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'calculationId': calculationId,
      },
    });
  }

  /**
   * @returns WorkbenchCalculationDto OK
   * @throws ApiError
   */
  public static updateWorkbenchCalculation({
    projectReference,
    workbenchId,
    calculationId,
    requestBody,
  }: {
    projectReference: string,
    workbenchId: string,
    calculationId: string,
    requestBody?: WorkbenchCalculationDto,
  }): CancelablePromise<WorkbenchCalculationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/calculations/{calculationId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'calculationId': calculationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static deleteWorkbenchCalculation({
    projectReference,
    workbenchId,
    calculationId,
  }: {
    projectReference: string,
    workbenchId: string,
    calculationId: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/calculations/{calculationId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'calculationId': calculationId,
      },
    });
  }

  /**
   * @returns MeasurementValueDto OK
   * @throws ApiError
   */
  public static getMeasurementValue({
    projectReference,
    workbenchId,
    measurementValueId,
  }: {
    projectReference: string,
    workbenchId: string,
    measurementValueId: string,
  }): CancelablePromise<MeasurementValueDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/measurementValues/{measurementValueId}',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
        'measurementValueId': measurementValueId,
      },
    });
  }

  /**
   * @returns MeasurementDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchMeasurements({
    projectReference,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectReference: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<MeasurementDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/measurements',
      path: {
        'projectReference': projectReference,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns TemplateDtoDataResponse OK
   * @throws ApiError
   */
  public static listTemplates({
    workbenchId,
    projectReference,
  }: {
    workbenchId: string,
    projectReference: string,
  }): CancelablePromise<TemplateDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/report/templates',
      path: {
        'workbenchId': workbenchId,
        'projectReference': projectReference,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static generateCsvReport({
    workbenchId,
    projectReference,
    requestBody,
  }: {
    workbenchId: string,
    projectReference: string,
    requestBody?: Array<string>,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/report/generateCsv',
      path: {
        'workbenchId': workbenchId,
        'projectReference': projectReference,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static generateReport({
    workbenchId,
    projectReference,
    templateId,
    formData,
  }: {
    workbenchId: string,
    projectReference: string,
    templateId?: string,
    formData?: {
      images?: Array<Blob>;
    },
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectReference}/workbenches/{workbenchId}/report/generate',
      path: {
        'workbenchId': workbenchId,
        'projectReference': projectReference,
      },
      query: {
        'templateId': templateId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

}
